import script from "./DashboardLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardLayout.vue?vue&type=style&index=0&id=8bbe9ce2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bbe9ce2"]])

export default __exports__